import updateUserDetails from '@dehaat/kisan-app-bl/api/updateUserDetails';
import { useRouter } from 'next/router';
import { MouseEventHandler, useContext } from 'react';
import { COOKIE_MAX_AGE_1YEAR, LANG_UPDATE_KEY, LOCALE_COOKIE_NAME, REDIRECT_URI_KEY, WEB_SOURCE_KEY } from '@/constants/common';
import { AuthContext } from '@/context/AuthProvider';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import { isCSCUser, resolveAsString } from '@/utils/helper';
import UserVerifiedIcon from './icons/UserVerifiedIcon';
import Paragraph, { VARIANT } from './Paragraph';
interface Props {
  name: string;
  alternate_name: string;
  background: string;
  color: string;
  locale: string;
  currentLangPref: string | null;
}
const LanguageSelector = ({
  name,
  alternate_name,
  background,
  color,
  locale,
  currentLangPref
}: Props) => {
  const {
    isAuthenticated
  } = useContext(AuthContext);
  const {
    replace,
    query
  } = useRouter();
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const href = currentLangPref == null ? '/location' : '/';
  const captureEvent = () => {
    if (currentLangPref == null) {
      trackCustomEvent(CustomEventTypes.ONBOARDING_LANGUAGE_SELECTION, locale);
    } else {
      trackCustomEvent(CustomEventTypes.LANGUAGE_UPDATE, JSON.stringify({
        from: currentLangPref,
        to: locale
      }));
    }
  };
  const onClick: MouseEventHandler<HTMLAnchorElement> = async e => {
    e.preventDefault();
    captureEvent();
    document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; max-age=${COOKIE_MAX_AGE_1YEAR}; path=/`;
    if (isAuthenticated) {
      await updateUserDetails({
        [LANG_UPDATE_KEY]: locale
      }, isCSCUser() ? Number(process.env.NEXT_PUBLIC_CSC_WEB_SOURCE_KEY) : WEB_SOURCE_KEY);
    }
    if (query && query[REDIRECT_URI_KEY]) {
      const redirectUrl = resolveAsString(query[REDIRECT_URI_KEY]);
      // This prevents redirection to external domains, ensuring security
      redirectUrl.startsWith('/') && !redirectUrl.includes('://') ? replace(redirectUrl, undefined, {
        locale
      }) : replace(href, undefined, {
        locale
      });
    } else {
      replace(href, undefined, {
        locale
      });
    }
  };
  return <a className={`p-3 rounded-xl text-center w-full ${background} ${color} flex items-center justify-center flex-col hover:scale-105 transition-transform relative cursor-pointer`} onClick={onClick} href={href} data-testid={`language-${locale}`} data-sentry-component="LanguageSelector" data-sentry-source-file="LanguageSelector.tsx">
      <h5>{name}</h5>
      <Paragraph variant={VARIANT.MEDIUM} className="mt-2" data-sentry-element="Paragraph" data-sentry-source-file="LanguageSelector.tsx">
        {alternate_name}
      </Paragraph>
      {currentLangPref === locale ? <UserVerifiedIcon className="right-[9.25px] bottom-[9.25px] absolute fill-primary-100 h-[17.5px] aspect-square" tickClassName="fill-transparent" /> : null}
    </a>;
};
export default LanguageSelector;